import { Maybe, Query, VlocDestinationData } from '@varo/graphql-schema-types';
import VaroLineOfCreditWhereToGo from 'services/graphql/queries/VaroLineOfCreditWhereToGo';
import { CombinedError, useQuery } from 'urql';

interface VaroLineOfCreditWhereToGoResult {
  result?: Maybe<VlocDestinationData>;
  error?: CombinedError;
  fetching: boolean;
  refetch: () => void;
}

const useVaroLineOfCreditWhereToGo = (): VaroLineOfCreditWhereToGoResult => {
  const [response, refetch] = useQuery<Query>({
    query: VaroLineOfCreditWhereToGo,
    requestPolicy: 'network-only',
    pause: true,
  });

  const { data, fetching, error } = response;

  return {
    result: data?.varoLineOfCreditWhereToGo,
    fetching,
    error,
    refetch,
  };
};

export default useVaroLineOfCreditWhereToGo;
